module.exports = __webpack_public_path__ + "static/media/blueSofa.06d00c62.svg";